import imprint from "../../constants/imprint";
import styles from "../../constants/styles";
import BackToHomeButton from "../shared/BackToHomeButton";

const Imprint = () => {
  return (
    <div className="flex flex-col items-center min-h-screen pt-4">
      <div className="flex flex-col items-start space-y-5">
        <BackToHomeButton />
        <h2 className={styles.secondaryHeading}>{imprint.heading}</h2>
        <h3 className={styles.tertiaryHeading}>{imprint.subHeading}</h3>
        <div className="flex flex-col space-y-2">
          <span className={styles.standardText}>{imprint.address.name}</span>
          <span className={styles.standardText}>{imprint.address.street}</span>
          <span className={styles.standardText}>{imprint.address.city}</span>
          <span className={styles.standardText}>{imprint.email}</span>
        </div>
      </div>
    </div>
  );
};

export default Imprint;
